import React from 'react';
import { Button } from './Button';
import { useInViewAnimation } from '../hooks/useInViewAnimation';

// Enterprise-style client wordmarks + your placeholder slot
const clients = [
  { name: 'MERIDIAN', sub: 'Facilities' },
  { name: 'NORTHWIND', sub: 'Logistics' },
  { name: 'AURORA', sub: 'Health' },
  { name: 'ORBIT', sub: 'Retail' },
  { name: 'PARADIGM', sub: 'Manufacturing' },
  { name: 'HELIX', sub: 'Real Estate' },
  { name: 'ATLAS', sub: 'Construction' },
  { name: 'YOUR LOGO', sub: 'Here' },
];

export function TrustedBySection() {
  const { ref, isInView } = useInViewAnimation();

  return (
    <section
      ref={ref}
      data-testid="trusted-by-section"
      className="w-full py-12 md:py-20 px-6"
    >
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-10 md:mb-12">
          <h2
            className={`text-[32px] md:text-[40px] lg:text-[44px] leading-[1.1] text-[#0D212C] tracking-tight ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
            style={{ animationDelay: '0.05s' }}
          >
            Trusted by <span className="font-serif grad-text">businesses worldwide</span>
          </h2>
          <p
            className={`text-sm md:text-base text-[#273C46] max-w-md ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
            style={{ animationDelay: '0.15s' }}
          >
            From ambitious startups to enterprises operating across continents, YP Nova is the engineering partner behind the outcome.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {clients.map((c, i) => {
            const isPlaceholder = c.name === 'YOUR LOGO';
            return (
              <div
                key={c.name + i}
                data-testid={`client-logo-${i}`}
                className={`h-24 md:h-28 rounded-2xl border flex flex-col items-center justify-center text-center transition-all duration-300 hover:-translate-y-1 ${
                  isPlaceholder
                    ? 'border-dashed border-[#7C3AED]/40 bg-white text-[#4C1D95]'
                    : 'border-[#7C3AED]/12 bg-white shadow-[0_2px_10px_rgba(0,0,0,0.03)] hover:shadow-[0_10px_36px_rgba(109,40,217,0.20)] hover:border-[#7C3AED]/40 text-[#0D212C]'
                } ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
                style={{ animationDelay: `${0.1 + i * 0.05}s` }}
              >
                <span className="font-mono text-sm md:text-base tracking-[0.25em]">{c.name}</span>
                <span className="text-[10px] uppercase tracking-widest text-[#273C46] mt-1">{c.sub}</span>
              </div>
            );
          })}
        </div>

        <div className={`mt-12 md:mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`} style={{ animationDelay: '0.5s' }}>
          <p className="text-lg md:text-xl text-[#0D212C]">
            <span className="font-serif">Let&rsquo;s build together.</span>
          </p>
          <Button to="/contact" variant="primary" data-testid="trusted-cta">
            Schedule a Discovery Call
          </Button>
        </div>
      </div>
    </section>
  );
}
